<template>
	<div class="multi-step__header">
        <span
            :class="{'is-active': currentstep === (index + 1)}"
            v-for="(step, index) in steps"
        />
	</div>
</template>

<script>
export default {
  name: 'step-navigation',
  props: ['steps', 'currentstep'],
  data() {
    return {
      indicatorclass: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?c0f39722